var ne = Object.defineProperty, se = Object.defineProperties;
var oe = Object.getOwnPropertyDescriptors;
var G = Object.getOwnPropertySymbols;
var ie = Object.prototype.hasOwnProperty, re = Object.prototype.propertyIsEnumerable;
var L = (h, m, p) => m in h ? ne(h, m, { enumerable: !0, configurable: !0, writable: !0, value: p }) : h[m] = p, R = (h, m) => {
  for (var p in m || (m = {}))
    ie.call(m, p) && L(h, p, m[p]);
  if (G)
    for (var p of G(m))
      re.call(m, p) && L(h, p, m[p]);
  return h;
}, Q = (h, m) => se(h, oe(m));
import "../../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getOssUrl as H } from "@oppein/op-utils";
import { defineComponent as de, useTemplateRef as J, watch as x, onMounted as ue, openBlock as c, createElementBlock as w, createElementVNode as y, createVNode as u, withCtx as i, createBlock as v, createTextVNode as M, createCommentVNode as b, Fragment as E, renderList as I } from "../../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as pe } from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as K, reactive as A, unref as s } from "../../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import W from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import { toDisplayString as ce, normalizeClass as fe } from "../../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import D from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import k from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import U from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import T from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import O from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import B from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import me from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import he from "../../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const ge = { class: "tw:!p-4" }, ye = { class: "clearfix" }, ve = { class: "img-box" }, be = ["src", "onClick"], we = { class: "fix-img" }, ke = ["src"], _e = {
  key: 0,
  style: { margin: "10px 0" }
}, qe = { class: "dialog-footer" }, Pe = /* @__PURE__ */ de({
  __name: "index",
  props: {
    productCell: {},
    callbackProduct: { type: Boolean },
    index: {},
    content: {},
    openType: {}
  },
  emits: ["deleteCell", "submitProduct"],
  setup(h, { emit: m }) {
    const p = h, S = m, X = J("GroundMass"), N = J("groundMassForm"), _ = pe(), C = K(!1), q = K([]), e = A({
      name: "",
      shape: "",
      section: "",
      color: "",
      length: "",
      width: "",
      direction: "",
      radius: "",
      beveled: "",
      quantity: ""
    }), n = A({
      shape: [],
      section: [],
      color: [],
      direction: [],
      radius: [],
      beveled: [],
      length: [],
      width: []
    }), r = A({
      appearance: [
        {
          type: "select",
          model: "section",
          list: "section",
          name: "石基截面",
          placeholder: "请选择",
          show: !0,
          readonly: !0
        },
        {
          type: "select",
          model: "color",
          list: "color",
          name: "石基颜色",
          placeholder: "请选择",
          show: !0,
          readonly: !0
        }
      ],
      specification: [
        {
          type: "input",
          model: "length",
          list: "length",
          name: "石基长度",
          placeholder: "请输入",
          show: !0,
          readonly: !0
        },
        {
          type: "input",
          model: "width",
          list: "width",
          name: "石基宽度",
          placeholder: "请输入",
          show: !0,
          readonly: !0
        },
        {
          type: "select",
          model: "direction",
          list: "direction",
          name: "方向",
          placeholder: "根据长度和宽度计算",
          show: !0,
          readonly: !1
        },
        {
          type: "select",
          model: "radius",
          list: "radius",
          name: "半径",
          placeholder: "请选择",
          show: !0,
          readonly: !0
        },
        {
          type: "select",
          model: "beveled",
          list: "beveled",
          name: "斜边长",
          placeholder: "请选择",
          show: !0,
          readonly: !0
        }
      ]
    }), Z = {
      shape: [{ required: !0, message: "请选择石基形状", trigger: ["blur", "change"] }],
      section: [{ required: !0, message: "请选择石基截面", trigger: ["blur", "change"] }],
      color: [{ required: !0, message: "请选择石基颜色", trigger: ["blur", "change"] }],
      length: [{ required: !0, message: "请输入石基长度", trigger: ["blur", "change"] }],
      width: [{ required: !0, message: "请输入石基宽度", trigger: ["blur", "change"] }],
      direction: [{ required: !0, message: "请选择方向", trigger: ["blur", "change"] }],
      radius: [{ required: !0, message: "请选择半径", trigger: ["blur", "change"] }],
      beveled: [{ required: !0, message: "请选择斜边长", trigger: ["blur", "change"] }],
      quantity: [{ required: !0, message: "请输入数量", trigger: ["blur", "change"] }]
    }, V = (t) => {
      e[t] = e[t].replace(/[^\d^.]+/g, "");
    }, ee = () => {
      e.quantity = e.quantity.replace(/[^\d]/g, "").replace(".", ""), e.quantity && parseInt(e.quantity, 10) > 200 && (e.quantity = "200", _.warning("数量输入最大值为 200"));
    }, le = (t) => {
      p.openType !== "view" && (e.shape = t);
    }, F = (t) => {
      Object.keys(r).forEach((l) => {
        r[l].forEach((o) => {
          o.show = t.includes(o.name), o.show || (e[o.model] = "");
        });
      });
    }, P = (t, l = "") => {
      n[t] = [];
      const o = t === "section" ? q.value : [];
      let a = [];
      l ? a = o.filter((f) => f.name.includes(l)) : a = [...o], t === "shape" ? n[t] = a.map((f) => ({
        name: f.name,
        sketchMap: f.sketchMap || ""
      })) : n[t] = a;
    }, $ = () => {
      C.value = !1, S("deleteCell", p.index);
    }, Y = (t, l) => {
      const o = {};
      return t.reduce((a, f) => (o[f[l]] || (o[f[l]] = !0, a.push(f)), a), []);
    }, j = (t) => {
      e.length = t, e.width = t;
    }, z = (t) => {
      if (e.shape.includes("扇形")) {
        const l = Number(e.width) || 0, o = Number(e.length) || 0;
        l > 2600 ? (e.width = "2600", _.warning("扇形石基长+宽不得大于2600!")) : o > 2600 ? (e.length = "2600", _.warning("扇形石基长+宽不得大于2600!")) : l + o > 2600 && (t && (e[t] = "0"), _.warning("扇形石基长+宽不得大于2600!"));
      }
      if (e.shape.includes("直线形") && (Number(e.length) || 0) > 2800 && (e.length = "2800", _.warning("直线形石基长度不得大于2800!")), e.width && e.length && !e.shape.includes("F-刀形")) {
        const l = Number(e.length) || 0, o = Number(e.width) || 0;
        ["S-方形", "D-钻石形", "F-扇形"].some((a) => e.shape.includes(a)) ? l > o ? e.direction = "左向" : l === o ? e.direction = "对称" : e.direction = "右向" : e.direction = "";
      } else
        e.direction = "";
    };
    return x(
      () => p.callbackProduct,
      (t) => {
        t && N.value && N.value.validate().then(
          () => {
            const l = Q(R({}, e), {
              name: p.productCell.name,
              quantity: String(Number(e.quantity) || 0)
            });
            S("submitProduct", l);
          },
          () => {
            _.warning("部分必填项填写有误！");
          }
        );
      }
    ), x(
      () => e.shape,
      (t, l) => {
        t !== l && l && (e.length = "", e.width = ""), [
          "D-钻石形",
          "F-扇形",
          "A-全弧形",
          "F-刀形",
          "U-U形",
          "E-E形",
          "T-T形",
          "Y-Y形"
        ].some((g) => t.includes(g)) ? (P("section", "50×60"), e.section = "50×60") : P("section");
        const a = ["L-直线形"], f = ["U-U形", "Y-Y形", "T-T形", "E-E形", "A-全弧形"], d = ["S-方形", "F-刀形"], te = ["D-钻石形"], ae = ["F-扇形"];
        a.some((g) => t.includes(g)) ? F(["石基截面", "石基颜色", "石基长度"]) : f.some((g) => t.includes(g)) ? F(["石基截面", "石基颜色", "石基长度", "石基宽度"]) : d.some((g) => t.includes(g)) ? F(["石基截面", "石基颜色", "石基长度", "石基宽度", "方向"]) : te.some((g) => t.includes(g)) ? F(["石基截面", "石基颜色", "石基长度", "石基宽度", "方向", "斜边长"]) : ae.some((g) => t.includes(g)) && F(["石基截面", "石基颜色", "石基长度", "石基宽度", "方向", "半径"]), t.includes("F-刀形") ? (r.specification[2].type = "select", n.direction = [{ name: "左向" }, { name: "右向" }], r.specification[2].readonly = !0, r.specification[2].placeholder = "请选择") : (r.specification[2].type = "input", r.specification[2].readonly = !1, r.specification[2].placeholder = "根据长度和宽度计算"), t.includes("F-扇形") ? (n.radius = [{ name: "550" }], e.radius = "550") : (n.radius = [], e.radius = ""), t.includes("A-全弧形") ? (r.specification[0].type = "select", r.specification[1].type = "select", r.specification[0].placeholder = "请选择", r.specification[1].placeholder = "请选择", n.length = [{ name: "900" }, { name: "1000" }], n.width = [{ name: "900" }, { name: "1000" }]) : t.includes("F-刀形") ? (r.specification[1].type = "select", r.specification[1].placeholder = "请选择", n.width = [{ name: "850" }, { name: "900" }]) : (r.specification[0].placeholder = "请输入", r.specification[1].placeholder = "请输入", r.specification[0].type = "input", r.specification[1].type = "input", n.length = [], n.width = []), t.includes("D-钻石形") ? n.beveled = [{ name: "636" }] : n.beveled = [], t.includes("F-刀形") || z(), N.value && N.value.restoreValidation();
      }
    ), x(
      () => e.length,
      (t) => {
        e.shape.includes("A-全弧形") ? j(t) : e.shape.includes("F-刀形") || z("length");
      }
    ), x(
      () => e.width,
      (t) => {
        e.shape.includes("A-全弧形") ? j(t) : e.shape.includes("F-刀形") || z("width");
      }
    ), ue(() => {
      p.productCell.options.forEach((l) => {
        if (l.name.includes("形状") && n.shape.push({
          name: l.name.split("：").pop() || "",
          sketchMap: l.sketchMap || ""
        }), l.name.includes("截面")) {
          const o = l.name.split("，");
          o.length > 1 ? o.forEach((a) => {
            a.includes("截面") && q.value.push({ name: a.split("：").pop() || "" });
          }) : q.value.push({ name: l.name.split("：").pop() || "" });
        }
        l.name.includes("颜色") && n.color.push({ name: l.name.split("：").pop() || "" }), l.name.includes("方向") && n.direction.push({ name: l.name.split("：").pop() || "" }), l.name.includes("半径") && n.radius.push({ name: l.name.split("：").pop() || "" }), l.name.includes("斜边长") && n.beveled.push({ name: l.name.split("：").pop() || "" });
      }), Object.keys(n).forEach((l) => {
        n[l] = Y(n[l], "name");
      }), q.value = Y(q.value, "name"), n.section = [...q.value];
      const t = p.content || {};
      e.name = t.name || "", e.shape = t.shape || "", e.section = t.section || "", e.color = t.color || "", e.length = t.length || "", e.width = t.width || "", e.direction = t.direction || "", e.radius = t.radius || "", e.beveled = t.beveled || "", e.quantity = t.quantity || "";
    }), (t, l) => (c(), w("div", null, [
      y("div", ge, [
        u(s(me), {
          model: e,
          "label-placement": "left",
          rules: Z,
          size: "small",
          ref_key: "groundMassForm",
          ref: N,
          inline: ""
        }, {
          default: i(() => [
            u(s(W), { class: "box-card" }, {
              header: i(() => [
                y("div", ye, [
                  y("span", null, ce(t.productCell.name), 1),
                  t.openType !== "view" ? (c(), v(s(D), {
                    key: 0,
                    style: { float: "right" },
                    type: "primary",
                    size: "small",
                    onClick: $
                  }, {
                    default: i(() => l[5] || (l[5] = [
                      M(" 删除 ", -1)
                    ])),
                    _: 1,
                    __: [5]
                  })) : b("", !0)
                ])
              ]),
              default: i(() => {
                var o;
                return [
                  u(s(k), null, {
                    default: i(() => [
                      y("div", ve, [
                        (c(!0), w(E, null, I(n.shape, (a, f) => (c(), w("img", {
                          class: fe(a.name === e.shape ? "border-bold" : ""),
                          key: f,
                          src: s(H)({ url: a.sketchMap }),
                          onClick: (d) => le(a.name)
                        }, null, 10, be))), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  y("div", we, [
                    n.shape.find((a) => a.name === e.shape) ? (c(), w("img", {
                      key: 0,
                      src: s(H)({ url: (o = n.shape.find((a) => a.name === e.shape)) == null ? void 0 : o.sketchMap })
                    }, null, 8, ke)) : b("", !0)
                  ]),
                  u(s(k), null, {
                    default: i(() => [
                      n.section.length || n.section.length || n.color.length ? (c(), w("div", _e, " 石基外形 ")) : b("", !0)
                    ]),
                    _: 1
                  }),
                  u(s(k), {
                    class: "transform-right",
                    style: { display: "flex", "flex-wrap": "wrap", gap: "16px" }
                  }, {
                    default: i(() => [
                      n.shape.length ? (c(), v(s(U), {
                        key: 0,
                        span: 7
                      }, {
                        default: i(() => [
                          u(s(T), {
                            label: "石基形状",
                            size: "small",
                            path: "shape"
                          }, {
                            default: i(() => [
                              u(s(O), {
                                value: e.shape,
                                "onUpdate:value": l[0] || (l[0] = (a) => e.shape = a),
                                placeholder: "请选择",
                                disabled: t.openType === "view",
                                options: n.shape.map((a) => ({ label: a.name, value: a.name }))
                              }, null, 8, ["value", "disabled", "options"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })) : b("", !0),
                      (c(!0), w(E, null, I(r.appearance, (a, f) => (c(), v(s(U), {
                        span: 7,
                        key: f
                      }, {
                        default: i(() => [
                          a.show ? (c(), v(s(T), {
                            key: 0,
                            label: a.name,
                            size: "small",
                            path: a.model
                          }, {
                            default: i(() => [
                              a.type === "input" ? (c(), v(s(B), {
                                key: 0,
                                value: e[a.model],
                                "onUpdate:value": (d) => e[a.model] = d,
                                clearable: "",
                                disabled: !a.readonly || t.openType === "view",
                                placeholder: a.placeholder,
                                onInput: (d) => V(a.model)
                              }, null, 8, ["value", "onUpdate:value", "disabled", "placeholder", "onInput"])) : a.type === "select" ? (c(), v(s(O), {
                                key: 1,
                                disabled: !a.readonly || t.openType === "view",
                                placeholder: a.placeholder,
                                size: "small",
                                value: e[a.model],
                                "onUpdate:value": (d) => e[a.model] = d,
                                options: n[a.list].map((d) => ({
                                  label: d.name,
                                  value: d.name
                                }))
                              }, null, 8, ["disabled", "placeholder", "value", "onUpdate:value", "options"])) : b("", !0)
                            ]),
                            _: 2
                          }, 1032, ["label", "path"])) : b("", !0)
                        ]),
                        _: 2
                      }, 1024))), 128))
                    ]),
                    _: 1
                  }),
                  u(s(k), null, {
                    default: i(() => l[6] || (l[6] = [
                      y("div", { style: { margin: "6px 0" } }, "石基规格", -1)
                    ])),
                    _: 1,
                    __: [6]
                  }),
                  u(s(k), {
                    class: "transform-right",
                    style: { display: "flex", "flex-wrap": "wrap", gap: "16px" }
                  }, {
                    default: i(() => [
                      (c(!0), w(E, null, I(r.specification, (a, f) => (c(), v(s(U), {
                        span: 7,
                        key: f
                      }, {
                        default: i(() => [
                          a.show ? (c(), v(s(T), {
                            key: 0,
                            label: a.name,
                            size: "small",
                            path: a.model
                          }, {
                            default: i(() => [
                              a.type === "input" ? (c(), v(s(B), {
                                key: 0,
                                value: e[a.model],
                                "onUpdate:value": (d) => e[a.model] = d,
                                clearable: "",
                                maxlength: 4,
                                disabled: !a.readonly || t.openType === "view",
                                placeholder: a.placeholder,
                                onInput: (d) => V(a.model)
                              }, null, 8, ["value", "onUpdate:value", "disabled", "placeholder", "onInput"])) : a.type === "select" ? (c(), v(s(O), {
                                key: 1,
                                disabled: !a.readonly || t.openType === "view",
                                placeholder: a.placeholder,
                                size: "small",
                                value: e[a.model],
                                "onUpdate:value": (d) => e[a.model] = d,
                                options: n[a.list].map((d) => ({
                                  label: d.name,
                                  value: d.name
                                }))
                              }, null, 8, ["disabled", "placeholder", "value", "onUpdate:value", "options"])) : b("", !0)
                            ]),
                            _: 2
                          }, 1032, ["label", "path"])) : b("", !0)
                        ]),
                        _: 2
                      }, 1024))), 128))
                    ]),
                    _: 1
                  }),
                  u(s(k), null, {
                    default: i(() => l[7] || (l[7] = [
                      y("div", { style: { margin: "6px 0" } }, "数量", -1)
                    ])),
                    _: 1,
                    __: [7]
                  }),
                  u(s(k), { class: "transform-right" }, {
                    default: i(() => [
                      u(s(U), { span: 7 }, {
                        default: i(() => [
                          u(s(T), {
                            label: " ",
                            size: "small",
                            path: "quantity"
                          }, {
                            default: i(() => [
                              u(s(B), {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                                disabled: t.openType === "view",
                                value: e.quantity,
                                "onUpdate:value": l[1] || (l[1] = (a) => e.quantity = a),
                                onInput: ee
                              }, null, 8, ["disabled", "value"]),
                              l[8] || (l[8] = y("span", { style: { "margin-left": "8px" } }, "支", -1))
                            ]),
                            _: 1,
                            __: [8]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        u(s(he), {
          ref: "dialog",
          bordered: "",
          show: C.value,
          "onUpdate:show": l[4] || (l[4] = (o) => C.value = o),
          "mask-closable": !1,
          to: X.value || "body",
          class: "tw:!z-[10000]"
        }, {
          default: i(() => [
            u(s(W), {
              size: "small",
              closable: "",
              role: "dialog",
              class: "tw:!w-[30%] tw:!text-left",
              bordered: !1,
              title: "删除确认",
              onClose: l[3] || (l[3] = (o) => C.value = !1)
            }, {
              footer: i(() => [
                y("div", qe, [
                  u(s(D), {
                    type: "primary",
                    size: "small",
                    onClick: $
                  }, {
                    default: i(() => l[9] || (l[9] = [
                      M(" 确认 ", -1)
                    ])),
                    _: 1,
                    __: [9]
                  }),
                  u(s(D), {
                    type: "primary",
                    size: "small",
                    onClick: l[2] || (l[2] = (o) => C.value = !1)
                  }, {
                    default: i(() => l[10] || (l[10] = [
                      M(" 取消 ", -1)
                    ])),
                    _: 1,
                    __: [10]
                  })
                ])
              ]),
              default: i(() => [
                l[11] || (l[11] = y("p", { style: { "text-align": "center" } }, "是否确定删除", -1))
              ]),
              _: 1,
              __: [11]
            })
          ]),
          _: 1
        }, 8, ["show", "to"])
      ])
    ]));
  }
});
export {
  Pe as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/GroundMass/components/index.vue.js
// module id = 1192
// module chunks = 41